import React, { useEffect, useState } from "react"
import { Button, Card, Col, Form, Row } from "react-bootstrap"
import { XSquareFill } from "react-bootstrap-icons"
import { useTranslation } from "react-i18next"
import { insert } from "../../utils/commonFunctions"

const MasterParcel = ({
    masterParcel,
    parcelItems,
    setParcelItems,
    selectedItems,
    setSelectedItems,
    isInvalid,
    setIsInValid,
    splittedItems,
    setSplittedItems,
    newParcels,
    setNewParcels,
    counter,
    setCounter,
    NewParcelUuid = "",
    NewParcelId = "",
    originalParcelItems = [],
    index = undefined,
    assign = false,
    view = false,
    fulfillmentSuites = undefined
}: {
    masterParcel: boolean
    parcelItems: Record<string, any>[]
    setParcelItems: Function
    selectedItems: Record<string, any>[]
    setSelectedItems: Function
    isInvalid: number[]
    setIsInValid: Function
    splittedItems: Record<string, any>
    setSplittedItems: Function
    newParcels: any[]
    setNewParcels: Function
    counter: number
    setCounter: Function
    NewParcelUuid?: string
    NewParcelId?: string
    originalParcelItems?: Record<string, any>[]
    index?: number
    assign?: boolean
    view?: boolean
    fulfillmentSuites?: Record<string, any>[]
}) => {
    const { t } = useTranslation()
    const [splitType, setSplitType] = useState(assign ? "new" : "existing")
    const [noOfBoxes, setNoOfBoxes] = useState(assign ? 1 : 0)
    const [ffSuite, setFfSuite] = useState(0)
    const [isDisabled, setIsDisabled] = useState(false)
    const handleDeleteSplittedItem = (itemId: number) => {
        const tempNewParcels = newParcels?.filter((np) => Object.keys(np)[0] !== NewParcelId)
        const otherParcelsHasItem = [].concat
            .apply(
                [],
                tempNewParcels
                    ?.filter((_) =>
                        (Object.values(_)[0] as Record<string, any>[])?.find((_) => _?.item_id === itemId)
                    )
                    ?.map((_) => Object.values(_)[0]) as ConcatArray<never>[]
            )
            ?.filter((_: Record<string, any>) => _?.item_id === itemId)
        const tempNewParcelItems = Object.values(
            newParcels?.find((np) => Object.keys(np)[0] === NewParcelId)
        )[0] as Record<string, any>[]
        if (tempNewParcelItems && tempNewParcelItems?.length > 1) {
            let newParentParcel = newParcels?.find((np) => Object.keys(np)[0] === NewParcelId)
            const newItems = (Object.values(newParentParcel)[0] as Record<string, any>[])?.filter(
                (item: Record<string, any>) => item?.item_id !== itemId
            )
            newParentParcel[NewParcelId] = [...newItems]
            if (index !== undefined) {
                insert(tempNewParcels, index, newParentParcel)
            }
            setNewParcels([...tempNewParcels])
        } else if (tempNewParcelItems && tempNewParcelItems?.length === 1) {
            setNewParcels([...tempNewParcels])
            setCounter(counter - 1)
        }
        const indexOfParcelItem = parcelItems?.indexOf(parcelItems?.find((pi) => pi?.id === itemId) || {})
        // const indexOfOriginalParcelItem = originalParcelItems?.indexOf(originalParcelItems?.find(pi => pi?.id === itemId) || {})
        const originalParcelItem = originalParcelItems?.find((opi) => opi?.id === itemId)
        let tempItems = parcelItems
        const calculatedQuantity =
            originalParcelItem?.quantity -
            otherParcelsHasItem?.reduce(
                (previousValue: number, currentValue: Record<string, any>) =>
                    previousValue + currentValue?.quantity,
                0
            )
        if (indexOfParcelItem > -1) {
            tempItems = parcelItems?.filter((pi) => pi?.id !== itemId)
            // const calculatedQuantity = originalParcelItem?.quantity - (otherParcelsHasItem)?.reduce((previousValue: number, currentValue: Record<string, any>) =>
            //     previousValue + currentValue?.quantity, 0
            // )
            // insert(tempItems, indexOfParcelItem, { ...originalParcelItem, quantity: calculatedQuantity })
        }
        // else if (indexOfParcelItem === -1 && indexOfOriginalParcelItem > -1) {
        //     insert(tempItems, indexOfOriginalParcelItem, originalParcelItem)
        // }
        insert(tempItems, indexOfParcelItem, { ...originalParcelItem, quantity: calculatedQuantity })
        setParcelItems([...tempItems])
    }

    const splitParcels = () => {
        let tempParcelItems = [...parcelItems]
        // let tempNewParcels = [] as Record<string, any>[]
        let tempCounter = counter
        selectedItems?.forEach((si: Record<string, any>) => {
            const parcelItem = tempParcelItems?.find((pi) => pi?.id === si?.item_id) || {}
            let splittedQuantity = Math.floor(si?.quantity / noOfBoxes)
            si.quantity = splittedQuantity
            if (si?.quantity <= parcelItem?.quantity) {
                const indexOfParcelItem = tempParcelItems?.indexOf(parcelItem)
                const updatedParcelItem = {
                    ...parcelItem,
                    quantity:
                        parcelItem?.quantity -
                        splittedQuantity *
                            (noOfBoxes >= 1 ? (splitType === "new" ? noOfBoxes : noOfBoxes - 1) : 0)
                }
                if (indexOfParcelItem > -1) {
                    const tempParcelItemWOSI = tempParcelItems?.filter((pi) => pi?.id !== si.item_id)
                    insert(tempParcelItemWOSI, indexOfParcelItem, updatedParcelItem)
                    tempParcelItems = [...tempParcelItemWOSI]
                }

                if (updatedParcelItem?.quantity <= 0) {
                    tempParcelItems = tempParcelItems?.filter((pi) => pi?.id !== si.item_id)
                }
            }
        })

        let tempNewParcels = [...newParcels]
        const loopLength = splitType === "new" ? noOfBoxes : noOfBoxes - 1
        for (let i = 0; i < loopLength; i++) {
            if (splitType === "new" || !tempNewParcels[i]) {
                tempNewParcels = [
                    ...tempNewParcels,
                    {
                        [assign
                            ? fulfillmentSuites?.find((ffs) => ffs?.id === ffSuite)?.suite
                            : `New Parcel ${tempCounter}`]: [...selectedItems]
                    }
                ]
                tempCounter += 1
            } else {
                // const loopLength = (noOfBoxes - 1) > newParcels?.length ? newParcels?.length : noOfBoxes - 1
                // for (let i = 0; i < loopLength; i++) {
                selectedItems?.forEach((si) => {
                    const itemInNewParcel = tempNewParcels[i][Object.keys(tempNewParcels[i])[0]]?.find(
                        (i: Record<string, any>) => i?.item_id === si?.item_id
                    )
                    if (itemInNewParcel) {
                        tempNewParcels[i] = {
                            [Object.keys(tempNewParcels[i])[0]]: [
                                ...(tempNewParcels[i][Object.keys(tempNewParcels[i])[0]] || [])?.map(
                                    (npi: Record<string, any>) =>
                                        npi?.item_id === itemInNewParcel?.item_id
                                            ? { ...npi, quantity: npi?.quantity + (si?.quantity || 0) }
                                            : npi
                                )
                            ]
                        }
                    } else {
                        tempNewParcels[i] = {
                            [Object.keys(tempNewParcels[i])[0]]: [
                                ...(tempNewParcels[i][Object.keys(tempNewParcels[i])[0]] || []),
                                si
                            ]
                        }
                    }
                })
                // }
            }
        }
        // setNewParcels([...(splitType === "new" ? newParcels : newParcels?.filter(np => !tempNewParcels?.map(npi => Object.keys(npi)[0])?.includes(Object.keys(np)[0]))), ...tempNewParcels])
        setNewParcels([...tempNewParcels])
        setCounter(tempCounter)
        setParcelItems([...tempParcelItems])
        setNoOfBoxes(assign ? 1 : 0)
        setSplittedItems({})
        setSelectedItems([])
    }

    useEffect(() => {
        let checkIsDisabled = false
        switch (assign) {
            case true:
                checkIsDisabled = selectedItems?.length === 0 || ffSuite === 0 || isInvalid?.length > 0
                break
            default:
                checkIsDisabled =
                    selectedItems?.length === 0 ||
                    noOfBoxes === 0 ||
                    (selectedItems?.reduce(
                        (previousValue: number, currentValue: Record<string, any>) =>
                            previousValue + currentValue?.quantity,
                        0
                    ) ===
                        parcelItems?.reduce(
                            (previousValue: number, currentValue: Record<string, any>) =>
                                previousValue + currentValue?.quantity,
                            0
                        ) &&
                        splitType === "new") ||
                    splitType === "" ||
                    isInvalid?.length > 0
                break
        }

        setIsDisabled(checkIsDisabled)
    }, [JSON.stringify(selectedItems), splitType, noOfBoxes, isInvalid?.length, ffSuite])

    return (
        <Card className={`${!masterParcel ? "mt-4" : ""} border-0 px-3`}>
            <Card.Title className="px-4 py-4">
                {masterParcel && !view ? (
                    t("Master parcel")
                ) : (
                    <h3>{assign || view ? NewParcelId : NewParcelUuid}</h3>
                )}
            </Card.Title>
            <Card.Body>
                <Row className={`header text-muted justify-content-${view ? "start" : "center"}`}>
                    {masterParcel && !view && <Col lg={1} />}
                    <Col className="text-start" lg={3}>
                        {t("Name")}
                    </Col>
                    <Col className="text-start" lg={3}>
                        {t("Quantity")}
                    </Col>
                    {masterParcel && !view ? (
                        <Col className="text-start" lg={3}>
                            {t("Split")}
                        </Col>
                    ) : !view ? (
                        <Col lg={3} />
                    ) : null}
                </Row>
                {(masterParcel
                    ? parcelItems
                    : (Object.values(newParcels?.find((np) => Object.keys(np)[0] === NewParcelId))[0] as Record<
                          string,
                          any
                      >[])
                )?.map((item: Record<string, any>, index: number) => (
                    <>
                        <Row
                            key={`item-${masterParcel ? item?.id : item?.item_id}`}
                            className={`justify-content-${view ? "start" : "center"}  ${index > 0 ? "my-2" : "mt-4"} align-items-center`}>
                            {masterParcel && !view && (
                                <Col lg={1}>
                                    <Form.Check
                                        type="checkbox"
                                        disabled={
                                            (item?.quantity === 1 && parcelItems?.length === 1) ||
                                            isInvalid?.includes(item?.id)
                                        }
                                        checked={selectedItems?.map((si) => si?.item_id)?.includes(item?.id)}
                                        onChange={(e: any) => {
                                            let invalids = [...isInvalid]
                                            if (e.target.checked) {
                                                const quantity =
                                                    splittedItems[`${item?.id}`] &&
                                                    splittedItems[`${item?.id}`] > 0
                                                        ? splittedItems[`${item?.id}`]
                                                        : item?.quantity
                                                setSplittedItems({ ...splittedItems, [item?.id]: quantity })
                                                let tempSI = [
                                                    ...selectedItems,
                                                    { item_id: item?.id, quantity, name: item?.item_name }
                                                ]
                                                setSelectedItems([...tempSI])
                                                if (
                                                    noOfBoxes > 0 &&
                                                    tempSI
                                                        ?.map((si) => {
                                                            if (si?.quantity < noOfBoxes) return true
                                                            else return false
                                                        })
                                                        ?.includes(true)
                                                ) {
                                                    invalids = [...invalids, -1]
                                                } else {
                                                    invalids = invalids?.filter((i) => i !== -1)
                                                }
                                            } else {
                                                // invalids = invalids?.filter(i => i !== -1)
                                                setSplittedItems({ ...splittedItems, [item?.id]: 0 })
                                                setSelectedItems(
                                                    selectedItems?.filter(
                                                        (si: Record<string, any>) => si?.item_id !== item?.id
                                                    )
                                                )
                                            }
                                            setIsInValid([...invalids])
                                        }}
                                    />
                                </Col>
                            )}
                            <Col className="text-start" lg={3}>
                                <Form.Control
                                    type="text"
                                    className="px-1"
                                    value={
                                        masterParcel
                                            ? item?.item_name
                                            : item?.name || item?.ParcelItem?.item_name
                                    }
                                    placeholder="Item Name..."
                                    readOnly
                                />
                            </Col>
                            <Col className="text-start" lg={3}>
                                <Form.Control
                                    type="text"
                                    className="px-1"
                                    value={item?.quantity}
                                    placeholder="Quantity..."
                                    readOnly
                                />
                            </Col>
                            {!view ? (
                                masterParcel ? (
                                    <Col className="text-start" lg={3}>
                                        <Form.Control
                                            type="number"
                                            disabled={item?.quantity === 1}
                                            min={0}
                                            max={item?.quantity}
                                            className="px-1"
                                            value={splittedItems[`${item?.id}`] || 0}
                                            onChange={(e: any) => {
                                                let invalids = [...isInvalid]
                                                setSplittedItems({
                                                    ...splittedItems,
                                                    [item?.id]: Number(e.target?.value)
                                                })
                                                if (
                                                    Number(e?.target?.value > item?.quantity) ||
                                                    Number(e.target?.value) <= 0
                                                ) {
                                                    invalids = [
                                                        ...invalids?.filter((i) => i !== item?.id),
                                                        item?.id
                                                    ]
                                                    if (
                                                        selectedItems?.find(
                                                            (si: Record<string, any>) =>
                                                                si?.item_id === item?.id
                                                        )?.item_id
                                                    ) {
                                                        setSelectedItems(
                                                            selectedItems?.filter(
                                                                (si: Record<string, any>) =>
                                                                    si?.item_id !== item?.id
                                                            )
                                                        )
                                                    }
                                                } else {
                                                    invalids = invalids?.filter((i) => i !== item?.id)
                                                    if (
                                                        selectedItems?.find(
                                                            (si: Record<string, any>) =>
                                                                si?.item_id === item?.id
                                                        )?.item_id
                                                    ) {
                                                        const selectedSplittedItem =
                                                            selectedItems?.find(
                                                                (si: Record<string, any>) =>
                                                                    si?.item_id === item?.id
                                                            ) || {}
                                                        const tempSelectedItems = [...selectedItems]
                                                        tempSelectedItems?.forEach((si) => {
                                                            if (si?.item_id === selectedSplittedItem?.item_id)
                                                                si.quantity = Number(e.target?.value)
                                                        })
                                                        setSelectedItems([...tempSelectedItems])
                                                    }
                                                }
                                                if (
                                                    noOfBoxes > 0 &&
                                                    (noOfBoxes > Number(e?.target?.value) / noOfBoxes ||
                                                        selectedItems
                                                            ?.map((si) => {
                                                                if (si?.quantity < noOfBoxes) return true
                                                                else return false
                                                            })
                                                            ?.includes(true))
                                                ) {
                                                    invalids = [...invalids?.filter((i) => i !== -1), -1]
                                                } else {
                                                    invalids = invalids?.filter((i) => i !== -1)
                                                }

                                                setIsInValid([...invalids])
                                            }}
                                            isInvalid={isInvalid?.includes(item?.id)}
                                        />
                                    </Col>
                                ) : (
                                    <Col lg={3}>
                                        <XSquareFill
                                            className="text-danger d-inline mx-1"
                                            role="button"
                                            onClick={() => handleDeleteSplittedItem(item?.item_id)}
                                        />
                                    </Col>
                                )
                            ) : null}
                        </Row>
                    </>
                ))}
            </Card.Body>
            {masterParcel && !view && (
                <Card.Footer className="bg-white border-0">
                    {!assign && (
                        <Row className="mb-4">
                            <Col className="d-flex justify-content-end align-items-center">
                                <Form.Check
                                    type="radio"
                                    name={"splitType"}
                                    label={t("Existing box(s)")}
                                    onChange={(e: any) => {
                                        setSplitType("existing")
                                    }}
                                    checked={splitType === "existing"}
                                    className="mx-5"
                                    defaultChecked={true}
                                />
                                <Form.Check
                                    type="radio"
                                    name={"splitType"}
                                    label={t("New Box")}
                                    onChange={(e: any) => {
                                        setSplitType("new")
                                    }}
                                    required={true}
                                    checked={splitType === "new"}
                                />
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col
                            md={{ span: assign ? 7 : 6, offset: assign ? 5 : 6 }}
                            className="d-flex justify-content-end align-items-start">
                            <small className={`text-muted font-small ${assign ? "w-25" : ""}`}>
                                {assign ? t("Select Fulfillment area") : t("No of boxes needed")}
                            </small>
                            {!assign ? (
                                <Form.Control
                                    type="number"
                                    min={1}
                                    max={100}
                                    className="px-1 mx-4"
                                    value={noOfBoxes}
                                    onChange={(e: any) => {
                                        setNoOfBoxes(Number(e?.target?.value))
                                        if (
                                            selectedItems
                                                ?.map((si) => {
                                                    if (si?.quantity < Number(e?.target?.value)) return true
                                                    else return false
                                                })
                                                ?.includes(true)
                                        ) {
                                            setIsInValid([...isInvalid?.filter((i) => i !== -1), -1])
                                        } else {
                                            setIsInValid(isInvalid?.filter((i) => i !== -1))
                                        }
                                        if (Number(e.target.value) === 1) {
                                            setSplitType("new")
                                        }
                                    }}
                                    isInvalid={isInvalid?.includes(-1)}
                                />
                            ) : (
                                <Form.Select
                                    disabled={selectedItems?.length === 0}
                                    value={ffSuite}
                                    className="text-capitalize mx-3 px-1"
                                    placeholder={t("FF area")}
                                    onChange={(e: any) => setFfSuite(Number(e?.target?.value))}>
                                    <option value={0} placeholder="Select FF area">
                                        Select area
                                    </option>
                                    {fulfillmentSuites
                                        ?.filter(
                                            (ffs) =>
                                                !newParcels
                                                    ?.map((np) => Object.keys(np)[0])
                                                    .includes(ffs?.suite)
                                        )
                                        ?.map((ffs: Record<string, any>) => (
                                            <option value={ffs?.id} key={ffs?.suite}>
                                                {ffs?.suite?.toUpperCase()}
                                            </option>
                                        ))}
                                </Form.Select>
                            )}
                            <Button
                                disabled={isDisabled}
                                id="btn-primary"
                                className="secondary-bg border-0 px-5 float-end"
                                onClick={() => splitParcels()}>
                                {assign ? t("Assign") : t("Split")}
                            </Button>
                        </Col>
                    </Row>
                </Card.Footer>
            )}
        </Card>
    )
}

export default MasterParcel
